// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useLedgerEnd } from '../ledger/useLedgerEnd';

const useBridgeHoldings: () => UseQueryResult<TemplateContract<Holding>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { crossChainRepresentative, party } = useParties();
  return useQuery({
    queryKey: ['queryBridgeHoldings', offset, ledgerApi, crossChainRepresentative, party],
    queryFn: async () => {
      return ledgerApi.queryBridgeHoldings(offset!, crossChainRepresentative, party);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useBridgeHoldings;
